import React, { useState, useEffect, useCallback, useMemo } from 'react';

function pad2(n) { return String(n).padStart(2, '0'); }
function fmtDate(d) { return d.getFullYear()+'-'+pad2(d.getMonth()+1)+'-'+pad2(d.getDate()); }
function getMesRange(m) { const a=m.getFullYear(),ms=m.getMonth(); return {di:fmtDate(new Date(a,ms,1)),df:fmtDate(new Date(a,ms+1,0))}; }

function FiscalDash({ estatisticas, onFiltrarMes, mesAtualProp, onAtualizar }) {
  const [mesAtual, setMesAtual] = useState(mesAtualProp || new Date());
  useEffect(() => { if(mesAtualProp) setMesAtual(mesAtualProp); }, [mesAtualProp]);
  const mudarMes = (dir) => { const d=new Date(mesAtual.getFullYear(),mesAtual.getMonth()+dir,1); setMesAtual(d); onFiltrarMes(d); };
  const voltarHoje = () => { const d=new Date(new Date().getFullYear(),new Date().getMonth(),1); setMesAtual(d); onFiltrarMes(d); };
  const mesNome = mesAtual.toLocaleDateString('pt-BR',{month:'long',year:'numeric'});
  const fmt = (v) => new Intl.NumberFormat('pt-BR',{style:'currency',currency:'BRL'}).format(Number(v||0));
  const est = useMemo(() => {
    const g=(k)=>({qtd:Number(estatisticas?.[k]?.quantidade??0),val:Number(estatisticas?.[k]?.valor??0)});
    return {pend:g('pendente'),lanc:g('lancada'),dev:g('devolucao'),arq:g('arquivada')};
  }, [estatisticas]);
  const tot = est.pend.qtd+est.lanc.qtd+est.arq.qtd;
  const valTot = est.pend.val+est.lanc.val+est.arq.val;
  const pctL = tot>0?Math.round((est.lanc.qtd/tot)*100):0;

  return (
    <div className="fiscal-dashboard">
      <div className="fiscal-dash-header">
        <div className="fiscal-mes-nav">
          <button className="pp-btn-outline pp-btn-sm" onClick={()=>mudarMes(-1)}>◀</button>
          <h2 className="fiscal-mes-titulo">{mesNome}</h2>
          <button className="pp-btn-outline pp-btn-sm" onClick={()=>mudarMes(1)}>▶</button>
          <button className="pp-btn-outline pp-btn-sm" onClick={voltarHoje}>📅 Hoje</button>
        </div>
        <button className="pp-btn-outline pp-btn-sm" onClick={onAtualizar}>↻ Atualizar</button>
      </div>
      <div className="fiscal-stats-grid">
        <div className="fiscal-stat-card fiscal-stat-total"><div className="fiscal-stat-icon">📊</div><div><div className="fiscal-stat-label">TOTAL DO MÊS</div><div className="fiscal-stat-value">{tot}</div><div className="fiscal-stat-money">{fmt(valTot)}</div></div></div>
        <div className="fiscal-stat-card"><div className="fiscal-stat-icon">⏳</div><div><div className="fiscal-stat-label">PENDENTES</div><div className="fiscal-stat-value">{est.pend.qtd}</div><div className="fiscal-stat-money">{fmt(est.pend.val)}</div><div className="fiscal-bar"><div className="fiscal-bar-fill fiscal-bar-amber" style={{width:tot>0?(est.pend.qtd/tot*100)+'%':'0%'}}></div></div></div></div>
        <div className="fiscal-stat-card"><div className="fiscal-stat-icon">✅</div><div><div className="fiscal-stat-label">LANÇADAS</div><div className="fiscal-stat-value">{est.lanc.qtd}</div><div className="fiscal-stat-money">{fmt(est.lanc.val)}</div><div className="fiscal-bar"><div className="fiscal-bar-fill fiscal-bar-green" style={{width:tot>0?(est.lanc.qtd/tot*100)+'%':'0%'}}></div></div></div></div>
      </div>
      <div className="fiscal-resumo-bar">Taxa de lançamento: <strong>{pctL}%</strong>{est.pend.qtd>0&&<span className="fiscal-alerta-pendente"> ⏳ {est.pend.qtd} pendente(s)</span>}</div>
    </div>
  );
}

function FiscalKanban({ notas=[], onAtualizar }) {
  const [sel, setSel] = useState(null);
  const lista = Array.isArray(notas)?notas:[];
  const fmt=(v)=>new Intl.NumberFormat('pt-BR',{style:'currency',currency:'BRL'}).format(v||0);
  const fmtCNPJ=(c)=>{if(!c)return '';const s=c.replace(/\D/g,'');return s.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/,'$1.$2.$3/$4-$5');};
  const filtrar=(s)=>lista.filter(n=>n.status===s);
  const calcTot=(s)=>filtrar(s).reduce((sum,n)=>sum+Number(n.valor_total||0),0);

  const lancarGC=async(nota)=>{
    try{const r=await fetch('/api/notas-fiscais/'+nota.id+'/xml/download');const b=await r.blob();const u=URL.createObjectURL(b);const a=document.createElement('a');a.href=u;a.download='NFe_'+(nota.numero_nf||nota.id)+'.xml';a.click();URL.revokeObjectURL(u);setTimeout(()=>window.open('https://app.gestaoclick.com/notas_fiscais_compras/importar_xml','_blank'),500);onAtualizar&&onAtualizar();}
    catch(e){console.error(e);alert('Erro ao baixar XML');}
  };
  const mudarSt=async(id,st)=>{try{await fetch('/api/notas-fiscais/'+id+'/status',{method:'PATCH',headers:{'Content-Type':'application/json'},body:JSON.stringify({status:st})});onAtualizar&&onAtualizar();}catch(e){console.error(e);}};

  const Col=({titulo,icone,status,cor})=>{
    const itens=filtrar(status);
    return(
      <div className={'fiscal-coluna fiscal-coluna-'+cor}>
        <div className="fiscal-col-header"><span>{icone} {titulo}</span><div className="fiscal-col-count">{itens.length}</div></div>
        <div className="fiscal-col-total">Total: {fmt(calcTot(status))}</div>
        <div className="fiscal-col-list">
          {itens.length===0&&<div className="fiscal-empty">Nenhuma nota</div>}
          {itens.map(n=>(
            <div key={n.id} className="fiscal-nota-card" onClick={()=>status==='pendente'&&setSel(n)} style={{cursor:status==='pendente'?'pointer':'default'}}>
              <div className="fiscal-nota-top"><span className="fiscal-nota-num">{n.numero_nf||'NF '+n.id}</span><span className="fiscal-nota-valor">{fmt(n.valor_total)}</span></div>
              <div className="fiscal-nota-fornecedor">{n.fornecedor_nome}</div>
              <div className="fiscal-nota-data">📅 {new Date(n.data_emissao).toLocaleDateString('pt-BR')}</div>
              {status==='lancada'&&<div className="fiscal-badge-lancada">✅ Verificada automaticamente</div>}
              {status==='devolucao'&&<div className="fiscal-badge-devolucao">↩️ Devolução/Retorno</div>}
              {status==='pendente'&&<div className="fiscal-nota-acoes"><button className="fiscal-btn fiscal-btn-lancar" onClick={e=>{e.stopPropagation();lancarGC(n);}}>📥 Lançar no GC</button><button className="fiscal-btn fiscal-btn-arquivar" onClick={e=>{e.stopPropagation();mudarSt(n.id,'arquivada');}}>🗄️ Arquivar</button></div>}
              {status==='arquivada'&&<div className="fiscal-nota-acoes"><button className="fiscal-btn fiscal-btn-restaurar" onClick={()=>mudarSt(n.id,'pendente')}>↩️ Restaurar</button></div>}
            </div>
          ))}
        </div>
      </div>
    );
  };

  return(
    <>
      <div className="fiscal-kanban-grid">
        <Col titulo="PENDENTE" icone="⏳" status="pendente" cor="pendente"/>
        <Col titulo="LANÇADA" icone="✅" status="lancada" cor="lancada"/>
        <Col titulo="DEVOLUÇÃO" icone="↩️" status="devolucao" cor="devolucao"/>
        <Col titulo="ARQUIVADA" icone="🗄️" status="arquivada" cor="arquivada"/>
      </div>
      {sel&&(
        <div className="fiscal-modal-overlay" onClick={()=>setSel(null)}>
          <div className="fiscal-modal" onClick={e=>e.stopPropagation()}>
            <div className="fiscal-modal-header"><h2>📋 Detalhes da Nota Fiscal</h2><button className="fiscal-modal-close" onClick={()=>setSel(null)}>✕</button></div>
            <div className="fiscal-modal-body">
              {[['Número NF:',sel.numero_nf||'N/A'],['Fornecedor:',sel.fornecedor_nome],['CNPJ:',fmtCNPJ(sel.fornecedor_cnpj)],['Valor Total:',fmt(sel.valor_total)],['Data Emissão:',new Date(sel.data_emissao).toLocaleDateString('pt-BR')],['Chave:',sel.chave_acesso],['Status:',sel.status?.toUpperCase()]].map(([l,v],i)=>(
                <div key={i} className="fiscal-detalhe-row"><span className="fiscal-detalhe-label">{l}</span><span className="fiscal-detalhe-value">{v}</span></div>
              ))}
            </div>
            <div className="fiscal-modal-footer"><button className="fiscal-btn fiscal-btn-lancar" onClick={()=>{lancarGC(sel);setSel(null);}}>📥 Lançar no GC</button><button className="fiscal-btn fiscal-btn-fechar" onClick={()=>setSel(null)}>Fechar</button></div>
          </div>
        </div>
      )}
    </>
  );
}

function GestaoFiscal() {
  const [notas, setNotas] = useState([]);
  const [estatisticas, setEstatisticas] = useState({});
  const [mesAtual, setMesAtual] = useState(new Date());
  const carregarDados = useCallback(async()=>{
    try{const{di,df}=getMesRange(mesAtual);const p='data_inicio='+di+'&data_fim='+df;const[r1,r2]=await Promise.all([fetch('/api/notas-fiscais?'+p),fetch('/api/notas-fiscais/estatisticas?'+p)]);const d1=await r1.json();const d2=await r2.json();setNotas(d1?.notas||[]);setEstatisticas(d2?.estatisticas||{});}
    catch(e){console.error(e);setNotas([]);setEstatisticas({});}
  },[mesAtual]);
  useEffect(()=>{carregarDados();},[carregarDados]);

  return(<div className="fiscal-page"><FiscalDash estatisticas={estatisticas} onFiltrarMes={setMesAtual} mesAtualProp={mesAtual} onAtualizar={carregarDados}/><FiscalKanban notas={notas} onAtualizar={carregarDados}/></div>);
}
export default GestaoFiscal;
